import {useIsClient, useMediaQuery} from 'usehooks-ts'

export const useIsMinMedium = () => {
    const isClient = useIsClient()
    const isMinMedium = useMediaQuery('(min-width: 768px)')
    return isClient ? isMinMedium : true
}
export const useIsMinLarge = () => {
    const isClient = useIsClient()
    const isMinLarge = useMediaQuery('(min-width: 1024px)')
    return isClient ? isMinLarge : true
}
